export default "__VITE_ASSET__CwZfxrlT__"